import { Component, Input, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { SystemService } from 'src/app/services/system.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Component({
  selector: 'app-service-log',
  templateUrl: './service-log.component.html',
  styleUrls: ['./service-log.component.css']
})
export class ServiceLogComponent implements OnInit {
  notes: { text: string; date: Date }[] = [];
  newNote: string = '';
  user = "";

  notes$: Observable<any[]>;

  @Input() params: { siteId: string; systemId: string; companyId: string };

  constructor(private systemService: SystemService, private authService: AuthService) { }

  ngOnInit() {
    this.notes$ = this.systemService.getServiceNotes$(this.params.systemId).pipe(
      map(notes => notes.map(note => ({
        ...note,
        date: moment.unix(note['createdAt']).format('YYYY-MM-DD HH:mm'),
        fromNow: moment.unix(note['createdAt']).fromNow()
      })))
    );
    this.authService.getUser$().subscribe(user => this.user = user.email);

    this.notes$.subscribe(notes => {
      console.log("Loaded notes:", notes);
    });
  }

  addNote() {
    if (this.newNote.trim()) {
      this.notes.unshift({ text: this.newNote.trim(), date: new Date() });

      const { siteId, systemId, companyId } = this.params;
      this.systemService.addServiceNote({
        description: this.newNote.trim(),
        createdAt: moment().unix(),
        createdBy: this.user,
        systemId,
        siteId,
        companyId,
        deleted: false
      });

      this.newNote = '';
    }
  }

  deleteNote(note: any) {
    if (confirm('Delete this note?')) {
      this.systemService.deleteServiceNote(note.id);
    }
  }
}
